import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import UploadCloudIcon from 'icons/UploadCloud.icon';

import './DropzoneActiveOverlay.styles.scss';

type DropzoneActiveOverlayProps = {
  className?: string;
  isVisible: boolean;
};

const DropzoneActiveOverlay: React.FC<DropzoneActiveOverlayProps> = (props) => {
  const { className, isVisible } = props;

  const classes = classNames(
    'dropzone-active-overlay',
    { 'dropzone-active-overlay--visible': isVisible },
    className,
  );

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <span>
        <UploadCloudIcon />
      </span>
      {t('dropFilesToStartUploading')}
    </div>
  );
};

export default DropzoneActiveOverlay;
